import React from 'react';
import styled from 'styled-components';
import { DateErrorTypo } from '../Typo';

const Component = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

interface DataErrorProps {
  addText?: string;
}

const DataError = ({ addText }: DataErrorProps) => {
  return (
    <Component>
      <DateErrorTypo>데이터가 없습니다.</DateErrorTypo>
      <DateErrorTypo>{addText}</DateErrorTypo>
    </Component>
  );
};

export default DataError;
